import { sanitize } from 'isomorphic-dompurify';

export const getSanitizedInnerHTML = (content: any) => {
  return {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    __html: sanitize(content),
  };
};
